import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { InputX } from 'components'
import styles from './index.module.css'

const CompanySearchNone = () => {

	const App = useApp()
	const [tabMenu, setTabMenu] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding pb_0">
				<ul className="tab-round-box">
					<li onClick={() => setTabMenu(0)} className={tabMenu === 0 ? "on" : ""}>회사명</li>
					<li onClick={() => setTabMenu(1)} className={tabMenu === 1 ? "on" : ""}>사업자 등록번호</li>
				</ul>

				<div className="form-group search-bar mt_30">
					<InputX type="text" placeholder="회사정보를 입력해보세요." defaultValue="주식회사 모니모니" id="" />
					<i className="icon icon_search" />
				</div>
			</div>
			<div className="center-cont">
				<i className="icon icon_no_data" />
				<p className="mt_20">'주식회사모니모니' 관련 검색 결과가 없어요.<br />
					검색어를 변경해 다시 검색해주세요.
				</p>
			</div>
			<div className="flex-shrink_0 padding">
				<div className="text-align_center" style={{ color: "#999", lineHeight: "2rem" }}>
					원하는 회사정보가 나오지 않는다면<br />
					사업자 등록번호로 검색해보세요!
				</div>
			</div>
		</div>
	)
}

export default CompanySearchNone